export function initialValuesGenerator(arr = []) {
  if (Array.isArray(arr)) {
    return arr.reduce((prev, current) => {
      return { ...prev, [current.name]: '' };
    }, {});
  }
  return Object.keys(arr).reduce((previous, key) => {
    const crr = arr[key].reduce((prev, current) => {
      return { ...prev, [current.name]: '' };
    }, {});

    return { ...previous, ...crr };
  }, {});
}
